module.exports = __webpack_public_path__ + "img/banner1.2f447aa0.jpg";